'use strict';

import Vue from 'vue';
import Router from 'vue-router';

import DownloadView from '../views/DownloadView.vue';
import HomeView from '../views/HomeView.vue';
import LoginView from '../views/LoginView.vue';
import ResetPasswordView from '../views/ResetPasswordView.vue';
import UserView from '../views/UserView.vue';
import DeleteUser from '../views/DeleteUser.vue';
import LostPhone from '../views/LostPhone.vue';
import ValidateView from '../views/ValidateView.vue';
import ValidateFromLinkView from '../views/ValidateFromLinkView.vue';
import FactoryResetRequestView from '../views/FactoryResetRequestView.vue';
import ProcessFactoryResetRequest from '../views/ProcessFactoryResetRequest';

import store from '../store';

import util from '../util.js';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: HomeView
    },
    {
      path: '/user',
      name: 'user',
      component: UserView
    },
    {
      path: '/download',
      name: 'download',
      component: DownloadView
    },
    {
      path: '/user/delete',
      name: 'userDelete',
      component: DeleteUser,
    },
    {
      path: '/login',
      name: 'login',
      component: LoginView,
      meta: {
        overrideAuth: true
      }
    },
    {
      path: '/reset',
      name: 'reset',
      component: ResetPasswordView,
      meta: {
        overrideAuth: true
      }
    },
    {
      path: '/lost',
      name: 'lost',
      component: LostPhone
    },
    {
      path: '/factoryresetrequest',
      name: 'factoryResetRequests',
      component: FactoryResetRequestView
    },
    {
      path: '/processfactoryresetrequest',
      name: 'processFactoryResetRequest',
      component: ProcessFactoryResetRequest
    },
    {
      path: '/validate',
      name: 'validate',
      component: ValidateView,
      meta: {
        overrideAuth: true
      }
    },
    {
      path: '/validateFromLink',
      name: 'validateFromLink',
      component: ValidateFromLinkView,
      meta: {
        overrideAuth: true
      }
    },
  ]
});

router.beforeEach((to, from, next) => {
  const loggedIn = Boolean(store.loggedIn);

  if (!loggedIn && !to.meta.overrideAuth) {
    return next({ name: 'login' });
  }

  if (loggedIn && to.name === 'login') {
    return next({ name: 'home' });
  }

  next();
});

export default router;
